export const companyNo = 'bdb0b12f-acc0-485f-bee4-f608dcb455dc'
export const projectType = '2gvi4squ'
export const BMAP_AK = "Vt2YanIsg3kluVSAx33g7LQZeD7wOsIs"